import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';
import { GeneralResponse } from '../../models/crear-cotizacion/general-response.model';
import { CotizadorTarifaColectivo } from '../../models/cotizador-tarifa-colectivo/cotizador-tarifa-colectivo.model';
import { CotizadorTarifaColectivoAnexo } from '../../models/cotizador-tarifa-colectivo/cotizador-tarifa-colectivo-anexo.model';

@Injectable({
  providedIn: 'root'
})
export class CotizadorTarifaColectivoService {

  private apiUrl = `${environment.HOST}${URL_MAP.API.COTIZADOR_TARIFA_COLECTIVO}`;

  constructor(private http: HttpClient) {}

  /**
   * GET /tarifa-colectivo?lineaNegocio=&programa=
   */
  consultarTarifasColectivo(
    lineaNegocio?: string,
    programa?: string
  ): Observable<GeneralResponse<CotizadorTarifaColectivo[]>> {

    let params = new HttpParams();

    if (lineaNegocio) {
      params = params.set('lineaNegocio', lineaNegocio);
    }

    if (programa) {
      params = params.set('programa', programa);
    }

    return this.http.get<GeneralResponse<CotizadorTarifaColectivo[]>>(
      this.apiUrl,
      { params }
    );
  }

  /**
   * GET /tarifa-colectivo/{id}
   */
  consultarTarifaPorId(
    idTarifaColectivo: number
  ): Observable<GeneralResponse<CotizadorTarifaColectivo>> {

    return this.http.get<GeneralResponse<CotizadorTarifaColectivo>>(
      `${this.apiUrl}/${idTarifaColectivo}`
    );
  }

  /**
   * GET /tarifa-colectivo/{id}/anexos
   */
  consultarAnexosPorTarifa(
    idTarifaColectivo: number
  ): Observable<GeneralResponse<CotizadorTarifaColectivoAnexo[]>> {

    return this.http.get<GeneralResponse<CotizadorTarifaColectivoAnexo[]>>(
      `${this.apiUrl}/${idTarifaColectivo}/anexos`
    );
  }

}